export default {
    init() {
    },
    finalize() {
        $('.custom-events .titles li').click(function() {
            $('.custom-events .titles li.current').removeClass('current');
            $('.custom-events .content.current').fadeOut(1000);
            $('.custom-events .content.current').removeClass('current');

            var eventIndex = $(this).data('index');

            $(`.custom-events .titles li[data-index="${eventIndex}"]`).addClass('current');
            $(`.custom-events .content[data-index="${eventIndex}"]`).fadeIn(2000);
            $(`.custom-events .content[data-index="${eventIndex}"]`).addClass('current');
        })

        $('.custom-events .next-event').click(function() {
            var nextEvent = $('.custom-events .content.current').data('index') + 1;

            if($('.custom-events .content.current').hasClass('last')) {
                nextEvent = 0;
            }

            $('.custom-events .titles li.current').removeClass('current');
            $('.custom-events .content.current').fadeOut(1000);
            $('.custom-events .content.current').removeClass('current');

            $(`.custom-events .titles li[data-index="${nextEvent}"]`).addClass('current');
            $(`.custom-events .content[data-index="${nextEvent}"]`).fadeIn(2000);
            $(`.custom-events .content[data-index="${nextEvent}"]`).addClass('current');
        })
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/custom-events.js